import web from "../web";

class EnseignantsService {
    index(token){
        return web.get("/api/enseignants", { headers: { "Content-Type": "multipart/form-data",'Authorization': 'Bearer '+token  } })
    }
    store(data, token){
        return web.post("api/enseignants", data,{ headers: { "Content-Type": "multipart/form-data",'Authorization': 'Bearer '+token } })
    }

    show(id,token){
        return web.get(`/api/enseignants/${id}/show`,{ headers: { "Content-Type": "multipart/form-data",'Authorization': 'Bearer '+token } })
    }

    update(data,token){
        return web.put("/api/enseignants/update", data,{ headers: { "Content-Type": "multipart/form-data",'Authorization': 'Bearer '+token } })
    }

    delete(id,token){
        return web.delete(`/api/enseignants/${id}/delete`,{ headers: { "Content-Type": "multipart/form-data",'Authorization': 'Bearer '+token } })
    }

    //get classe matiere enseignant
    getClasseEnseignant(id,token){
        return web.get(`/api/classesmatieresenseignants/${id}/show`,{ headers: { "Content-Type": "multipart/form-data",'Authorization': 'Bearer '+token } })
    }

    //get classe matiere enseignant
    getPersonnes(data,token){
        return web.get("/api/personnes", data,{ headers: { "Content-Type": "multipart/form-data",'Authorization': 'Bearer '+token } })
    }

    getEnseignantsByMatiere(id,token){
        return web.get(`/api/enseignants/matiere/${id}`,{ headers: { "Content-Type": "multipart/form-data",'Authorization': 'Bearer '+token } })
    }
}

export default new EnseignantsService()